// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/skeleton/style/index.less
// module id = 1132
// module chunks = 1